export const locale = {
    'PROPOSALS': {
        'TITLE': 'Proposals',
    },
};
